import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiResponse } from '@core/interface/api-response.interface';
import { UrlBuilder } from '@core/model/url-builder';
import { PurchaseChannelResponseDto } from '@domain/purchase-channel/dtos/purchase-channel.response.dto';
import { GetPurchaseChannelRequestDto } from '@domain/purchase-channel/dtos/get-purchase-channel.request.dto';
import { CreatePurchaseChannelRequestDto } from '@domain/purchase-channel/dtos/create-purchase-channel.request.dto';
import { ListPurchaseChannelRequestDto } from '@domain/purchase-channel/dtos/list-purchase-channel.request.dto';
import { PageableResponse } from '@core/interface/pageable.interface';
import { UpdatePurchaseChannelRequestDto } from '@domain/purchase-channel/dtos/update-purhcase-channel.request.dto';
import { UpdateStatePurchaseChannelRequestDto } from '@domain/purchase-channel/dtos/update-state-purhcase-channel.request.dto';
import { RefId } from '@core/interface/ref-id.interface';
import { AssignFastPaymentChannelRequestDto } from '@domain/purchase-channel/dtos/assign-fast-payment-channel.request.dto';

@Injectable({
    providedIn: 'root',
})
export class PurchaseChannelService extends UrlBuilder {
    constructor(private http: HttpClient) {
        super('purchase/channel');
    }

    create(request: CreatePurchaseChannelRequestDto) {
        const queryUrl = `${this.getApiUrl()}`;
        return this.http.post<ApiResponse<PurchaseChannelResponseDto>>(
            queryUrl,
            request,
        );
    }

    update(request: UpdatePurchaseChannelRequestDto) {
        const { refId } = request;
        const queryUrl = `${this.getApiUrl()}/${refId}`;
        return this.http.put<ApiResponse<PurchaseChannelResponseDto>>(
            queryUrl,
            request,
        );
    }

    updateState(request: UpdateStatePurchaseChannelRequestDto) {
        const { refId } = request;
        const queryUrl = `${this.getApiUrl()}/${refId}/state`;
        return this.http.patch<ApiResponse<PurchaseChannelResponseDto>>(
            queryUrl,
            request,
        );
    }

    show(request: RefId) {
        const { refId } = request;
        const queryUrl = `${this.getApiUrl()}/show/${refId}`;
        return this.http.get<ApiResponse<PurchaseChannelResponseDto>>(queryUrl, {});
    }

    list(request: ListPurchaseChannelRequestDto) {
        const queryUrl = `${this.getApiUrl()}/list`;
        return this.http.get<
            ApiResponse<PageableResponse<PurchaseChannelResponseDto>>
        >(queryUrl, { params: { ...request } });
    }

    get(request: GetPurchaseChannelRequestDto) {
        const queryUrl = `${this.getApiUrl()}/get`;
        return this.http.get<ApiResponse<PurchaseChannelResponseDto[]>>(
            queryUrl,
            { params: { ...request } },
        );
    }

    assignFastPayment(request: AssignFastPaymentChannelRequestDto) {
        const queryUrl = `${this.getApiUrl()}/assign/fast-payment`;
        return this.http.post<ApiResponse<void>>(queryUrl, request);
    }
}